// This function ensures strings will not render with widows (one word on one new line)
// Because strings containing links can be passed in as an array, need to check whether the input ends in a space
// If it does, change the second to last space to a nsbp, otherwise change the last space
// The function returns a __html object and needs to be used with dangerouslySetInnerHTML

import { createMarkup } from "./createMarkup"

export const preventWidow = (text: string): { __html: string } => {
  const lastChar = text.slice(text.length - 1, text.length)
  let lastSpace = text.lastIndexOf(" ")
  if (lastChar === " ") {
    lastSpace = text.lastIndexOf(" ", text.lastIndexOf(" ") - 1)
  }
  const textAsArray = text.split("")
  textAsArray[lastSpace] = `&nbsp;`
  return createMarkup(textAsArray.join(""))
}
